/**
 * Supabase public client configuration shared by browser, SSR, and middleware.
 *
 * Publishable Keys are the primary API key. The legacy anon key remains only as
 * a temporary migration fallback until every deployment has been verified.
 */
export const SUPABASE_URL = process.env.NEXT_PUBLIC_SUPABASE_URL;
export const SUPABASE_PUBLISHABLE_KEY =
  process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY ||
  process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

export const HAS_SUPABASE_PUBLIC_CONFIG = Boolean(
  SUPABASE_URL && SUPABASE_PUBLISHABLE_KEY,
);
